import { MenuInnerWithSub } from './MenuInnerWithSub'
import {MenuItem} from './MenuItem'
import {useIntl} from 'react-intl'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/admin/dashboard' />
       <MenuInnerWithSub
          title='Driver'
          to='#'
          icon='profile-user'
          hasArrow={true}
          menuPlacement='bottom-start'
          // menuTrigger={`{default:'click', lg: 'hover'}`}
          menuTrigger={`click`}
        >
          <MenuItem title='List Driver Air Crew' to='/admin/driver' />
          <MenuItem title='List Driver Citilink' to='/admin/citilink/driver' />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Log'
          to='#'
          icon='external-drive'
          hasArrow={true}
          menuPlacement='bottom-start'
          // menuTrigger={`{default:'click', lg: 'hover'}`}
          menuTrigger={`click`}
        >
          <MenuItem title='Log Rating Air Crew' to='/admin/log-rating' />
          <MenuItem title='Log Rating Citilink' to='/admin/citilink/log-rating' />
        </MenuInnerWithSub>
    </>
  )
}
